import type { ScoringResult } from '@mathflat/domain/Scoring'
import type { StudentWorkbookScoringDetail } from '@mathflat/domain/StudentWorkbook'
import { parseInt } from 'lodash-es'
import { makeAutoObservable } from 'mobx'

export class WorkbookScoringDTO {
  studentWorkbookProgressId: number //학생-교재 페이지 id
  workbookProblemId: number // 교재 문제 id
  userAnswer: string | null // 유저 답
  result: ScoringResult
  updateDatetime: StudentWorkbookScoringDetail['updateDatetime']
  assists: StudentWorkbookScoringDetail['assists']

  constructor(params: StudentWorkbookScoringDetail) {
    makeAutoObservable(this)
    this.studentWorkbookProgressId = params.studentWorkbookProgressId
    this.workbookProblemId = params.workbookProblemId
    this.userAnswer = params.userAnswer
    this.result = params.result
    this.updateDatetime = params.updateDatetime
    this.assists = params.assists
  }

  get id() {
    return WorkbookScoringDTO.encodeId(this)
  }

  get decodedId() {
    return WorkbookScoringDTO.decodeId(this.id)
  }

  static encodeId({
    studentWorkbookProgressId,
    workbookProblemId,
  }: Pick<WorkbookScoringDTO, 'studentWorkbookProgressId' | 'workbookProblemId'>) {
    return studentWorkbookProgressId + '-' + workbookProblemId
  }

  static decodeId(scoringId) {
    const [studentWorkbookProgressId, workbookProblemId] = scoringId.split('-')
    return {
      studentWorkbookProgressId: parseInt(studentWorkbookProgressId),
      workbookProblemId: parseInt(workbookProblemId),
    }
  }
}
